import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

export default function YesNoRadioGroup({
  name,
  label,
  ariaLabel,
  value,
  onChange,
  error,
  helperText,
  yesId,
  noId,
  sx,
  labelSx,
  helperTextSx,
  radioGroupSx,
}) {
  const intl = useIntl();
  return (
    <FormControl sx={{ mb: 2, ...sx }} error={error}>
      <FormLabel component="legend" sx={{ '&.Mui-focused': { color: 'text.primary' }, ...labelSx }}>
        {label}
      </FormLabel>
      <RadioGroup
        aria-label={ariaLabel ?? (typeof label === 'string' ? label : name)}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        row
        sx={radioGroupSx}
      >
        <FormControlLabel
          value="yes"
          control={<Radio color="primary" id={yesId} />}
          label={intl.formatMessage({ id: 'jobSearchActivity.form.yes' })}
        />
        <FormControlLabel
          value="no"
          control={<Radio color="primary" id={noId} />}
          label={intl.formatMessage({ id: 'jobSearchActivity.form.no' })}
        />
      </RadioGroup>
      {error && helperText && <FormHelperText sx={helperTextSx}>{helperText}</FormHelperText>}
    </FormControl>
  );
}

YesNoRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  yesId: PropTypes.string,
  noId: PropTypes.string,
  sx: PropTypes.object,
  labelSx: PropTypes.object,
  helperTextSx: PropTypes.object,
  radioGroupSx: PropTypes.object,
};
